import React from 'react'
import { Button } from 'antd'

export default (props) => {
  return (
    <Button onClick={props.onClick} style={{ fontSize: 12, borderRadius: 25 }}>
      {props.children}
    </Button>
  )
}
